import { useCallback } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { LOCAL_VIEWER_PATH, PATIENT_VIEWER_PATH } from './paths';

/**
 * Returns a function that moves a viewer on a connector patient's route to
 * the local viewer, keeping the workflow step. Call it once the data on
 * screen is no longer that connector patient's, so the address stops naming
 * a patient that is not loaded. The history entry is replaced, so Back does
 * not return to it. Does nothing on any other route.
 */
export function useLeavePatientRoute(): () => void {
    const navigate = useNavigate();
    const { search } = useLocation();
    const onPatientRoute = useMatch(PATIENT_VIEWER_PATH) !== null;

    return useCallback(() => {
        if (onPatientRoute) {
            navigate(
                { pathname: LOCAL_VIEWER_PATH, search },
                { replace: true }
            );
        }
    }, [navigate, onPatientRoute, search]);
}
